module.exports = __webpack_public_path__ + "img/ac1.86ecfc1f.jpg";